import { createAction, props } from '@ngrx/store';
import { DeliveryZone, DeliveryZoneForm } from '@core/models'
import { IResponseBadRequest } from '@core/interfaces';

export const DELIVERY_ZONE_FIND = createAction('[Delivery Zone] Find', props<{ id: string }>());
export const DELIVERY_ZONE_FIND_ALL = createAction('[Delivery Zone] Find All');

export const DELIVERY_ZONE_FIND_SUCCESS = createAction('[Delivery Zone] Find Success', props<{ deliveryZone: DeliveryZone }>());
export const DELIVERY_ZONE_FIND_ALL_SUCCESS = createAction('[Delivery Zone] Find All Success', props<{ deliveryZoneList: DeliveryZone[] }>());

export const DELIVERY_ZONE_FAILURE = createAction('[Delivery Zone] Failure', props<{ error: IResponseBadRequest }>());

export const DELIVERY_ZONE_UPDATE_LOADING = createAction('Delivery Zone] Update Loading', props<{ loading: boolean }>());

export const DELIVERY_ZONE_UPDATE_FORM = createAction('[Delivery Zone] Update Form', props<{ deliveryZoneForm: DeliveryZoneForm }>());

export const DELIVERY_ZONE_EDIT_MODE = createAction('[Delivery Zone] Edit Mode', props<{ editMode: boolean }>());

export const DELIVERY_ZONE_RESET = createAction('[Delivery Zone] Reset');

export const DELIVERY_ZONE_RESET_FORM = createAction('Delivery Zone] Reset Form');

export const DELIVERY_ZONE_RESET_ERROR = createAction('[Delivery Zone] Reset Error');

export const DELIVERY_ZONE_UPDATE_VIEW = createAction('[Delivery Zone] Update IView', props<{ deliveryZoneId: string }>());

export const DELIVERY_ZONE_REMOVE = createAction('Delivery Zone] Remove', props<{ id: string }>());

export const DELIVERY_ZONE_REMOVE_COMPLETED = createAction('[Delivery Zone] Remove completed');

export const DELIVERY_ZONE_CLEAR_STATE = createAction('[Delivery Zone] Clear state');

export const DELIVERY_ZONE_FIND_FORM_SUCCESS = createAction('[Delivery Zone] Find Form Success', props<{ deliveryZoneForm: DeliveryZoneForm }>());

export const DELIVERY_ZONE_CREATE = createAction('[Delivery Zone] Create');

export const DELIVERY_ZONE_UPDATE = createAction('[Delivery Zone] Update');

export const DELIVERY_ZONE_UPDATE_ID = createAction('[Delivery Zone] Update Id',props<{ deliveryZoneId: string }>());


export const DELIVERY_ZONE_FIND_BY_LOCATION = createAction('[Delivery Zone] Find By Location');
export const DELIVERY_ZONE_FIND_BY_LOCATION_SUCCESS = createAction('[Delivery Zone] Find By Location Success', props<{ deliveryZone: DeliveryZone }>());

export const DELIVERY_ZONE_FIND_BY_LOCATION_FAILURE = createAction('[Delivery Zone] Find By Location Failure', props<{ error: string }>());

export const DELIVERY_ZONE_UPDATE_AVAILABLE = createAction('[Delivery Zone] Update Available', props<{ deliveryZoneAvailable: DeliveryZone[] | null }>());


